module.exports = __webpack_public_path__ + "static/img/title_05.9979ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_05.png
// module id = Xrph
// module chunks = 1